import React, { useEffect, useState } from "react";

const Clock: React.FC = React.memo(() => {

    const [time, setTime] = useState(new Date().toLocaleTimeString());

    useEffect(() => {
        const id = setInterval(() => setTime(new Date().toLocaleTimeString()), 1000);
        return () => clearInterval(id);
    }, []);

    return <span className="temp-time">{time}</span>;

});

export default Clock;
